module.exports = __webpack_public_path__ + "img/bitcoin-btc-logo.d6a21bc3.png";